module.exports = __webpack_public_path__ + "img/product_41.28f7bed.svg";